import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';


export class SOPutEntity {

  constructor(
    public uid: string,
    public name: string = null,
    public description: string = null,
    public editPermissions: boolean = null,
    public project: SOGetProject = null,
    public organization: SOGetOrganization = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPutEntity(
      'uid' in params ? params.uid : null,
      'name' in params ? params.name : null,
      'description' in params ? params.description : null,
      'editPermissions' in params ? params.editPermissions : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
    );
  }
}
